// extracted by mini-css-extract-plugin
export default {"personalData":"PersonalData_personalData__aEo9m"};